import { Injectable } from '@angular/core';
import { BaseService } from 'cre-ng';

import { QuickApply } from '@app/shared/shared.models';

@Injectable()
export class JobPositionsService extends BaseService {
  getEndPoint(): string {
    return '/jobpositions/api/v1';
  }

  quickApply(application: QuickApply): Promise<string> {
    return this.httpClient.post<string>(this.serviceUrl + '/quickapply', application).toPromise();
  }
}
